/**
 * Copyright (c) 2021 TechDivision GmbH
 * All rights reserved
 */
;(function NavigationDoubleTapToGo() {
    /**
     * handles the visibility of the scroll to top button
     *
     * @constructor
     */
    function navigationDoubleTapToGo() {
        /**
         * local object availability
         * @private
         */
        var _this = this

        /**
         * @type {number}
         */
        this.navigationBarBreakpoint = 992

        /**
         * @method cacheDom
         *  assign {HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.doubleTapToGoElements = document.querySelectorAll('.js__double-tap-to-go')
        }

        /**
         * @method triggerDoubleTapToGo
         * @returns {undefined}
         */
        this.triggerDoubleTapToGo = function () {
            var screenWidth = window.screen.width
            if (screenWidth >= _this.navigationBarBreakpoint) {
                window.Energy.doubleTapToGo(_this.doubleTapToGoElements)
            }
        }

        /**
         * @method windowResize
         * @returns {undefined}
         */
        this.windowResize = function () {
            window.addEventListener('resize', _this.triggerDoubleTapToGo)
        }

        /**
         * @method init
         * @return {undefined}
         */
        this.init = function () {
            _this.cacheDom()
            _this.triggerDoubleTapToGo()
            _this.windowResize()
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Energy) {
        window.Energy = {}
    }

    window.Energy.navigationDoubleTapToGo = navigationDoubleTapToGo
})()

if (document.readyState != 'loading') {
    new window.Energy.navigationDoubleTapToGo()
} else {
    document.addEventListener('DOMContentLoaded', function () {
        new window.Energy.navigationDoubleTapToGo()
    })
}
